<script>
  import moment from 'moment';
  export let customerNotes = [];
  export let deleteNote = () => {};
  export let addNote = () => {};

  let newNote = null;
</script>

<div class="col" style="height: 375px; overflow: scroll;">
  <div class="text-center">
    <label for="newNote" class="form-label">Müşteri Notları</label>
    <input
      type="text"
      class="form-control text-center"
      id="newNote"
      placeholder="Yeni Not Ekle"
      bind:value={newNote}
    />
    <button
      on:click|preventDefault={addNote(newNote)}
      class="btn btn-success mt-2 mb-3">Ekle</button
    >
  </div>
  {#each customerNotes as note}
    <div class="row justify-content-center align-items-center mb-3">
      <div class="col-md-3">
        <input
          type="date"
          max={moment(new Date()).format('YYYY-MM-DD')}
          class="form-control"
          bind:value={note.date}
        />
      </div>
      <div class="col-md-8">
        <textarea
          type="text"
          class="form-control"
          style="resize: none;"
          bind:value={note.note}
        />
      </div>
      <div class="col-md-1 mt-2">
        <button
          on:click|preventDefault={deleteNote(note._id)}
          class="btn btn-danger">Sil</button
        >
      </div>
    </div>
  {/each}
</div>
